import React from 'react';
import ArticleCard from '../components/ArticleCard';
import { Article } from '../types/types';

interface LatestArticlesProps {
  articles: Article[];
}

const LatestArticles: React.FC<LatestArticlesProps> = ({ articles }) => {
  const featuredArticle = articles[0];
  const otherArticles = articles.slice(1);

  return (
    <div className="react-block__page-top-articles">
      <ArticleCard article={featuredArticle} cardType={4} />

      {otherArticles.map((article, index) => (
        <ArticleCard key={index} article={article} cardType={'half'} />
      ))}
    </div>
  );
};

export default LatestArticles;
